(() => {
  const mainImage = document.querySelector("#main-product-image");
  const galleryThumbs = document.querySelectorAll(".gallery-thumb");

  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      if (!mainImage) return;

      // The main photo carries a list of widths, so the list has to be swapped too.
      // Setting src on its own would leave the old list in place and the browser would
      // keep showing the previous photo.
      if (thumb.dataset.srcset) {
        mainImage.srcset = thumb.dataset.srcset;
      } else {
        mainImage.removeAttribute("srcset");
      }
      mainImage.src = thumb.dataset.image;
      mainImage.alt = thumb.dataset.alt;

      galleryThumbs.forEach((item) => {
        const isActive = item === thumb;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", String(isActive));
      });
    });
  });

  const planCards = document.querySelectorAll(".plan-card");
  const planRadios = document.querySelectorAll('input[name="purchase-option"]');
  const sellingPlanInput = document.querySelector("#selling-plan-input");
  const variantInput = document.querySelector('#buy-box-form input[name="id"]');
  const addToCartButton = document.querySelector("#buy-box-form .add-to-cart");

  const syncPurchaseOptions = () => {
    planCards.forEach((card) => {
      const radio = card.querySelector('input[name="purchase-option"]');
      const perks = card.querySelector(".plan-perks");
      const isSelected = Boolean(radio && radio.checked);

      card.classList.toggle("is-selected", isSelected);
      if (perks) perks.hidden = !isSelected;

      if (isSelected && radio) {
        if (sellingPlanInput) {
          sellingPlanInput.value = radio.dataset.sellingPlan || "";
        }

        // The 3 Month card is a different product (the 3-Pack), so the cart needs the
        // right product swapped in, not just the right plan.
        if (variantInput && radio.dataset.variantId) {
          variantInput.value = radio.dataset.variantId;
        }

        if (addToCartButton) {
          const isAvailable = radio.dataset.available !== "false";
          addToCartButton.disabled = !isAvailable;
          addToCartButton.textContent = isAvailable ? "Add to Cart" : "Coming Soon";
        }
      }
    });
  };

  planRadios.forEach((radio) => {
    radio.addEventListener("change", syncPurchaseOptions);
  });

  syncPurchaseOptions();

  document.querySelectorAll(".accordion-trigger").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const panelId = trigger.getAttribute("aria-controls");
      const panel = document.getElementById(panelId);
      if (!panel) return;

      const willOpen = trigger.getAttribute("aria-expanded") !== "true";
      trigger.setAttribute("aria-expanded", String(willOpen));
      panel.setAttribute("aria-hidden", String(!willOpen));
      panel.classList.toggle("is-open", willOpen);
    });
  });

  const modal = document.querySelector(".supplement-modal");
  const modalOpener = document.querySelector("[data-modal-open]");
  const modalClose = document.querySelector(".modal-close");
  let returnFocusTarget = null;

  const openModal = () => {
    if (!modal) return;

    returnFocusTarget = document.activeElement;
    document.body.classList.add("modal-open");
    modal.showModal();
    modalClose?.focus();
  };

  const closeModal = () => {
    if (!modal || !modal.open) return;
    modal.close();
  };

  modalOpener?.addEventListener("click", openModal);
  modalClose?.addEventListener("click", closeModal);

  modal?.addEventListener("click", (event) => {
    const panel = modal.querySelector(".modal-panel");
    if (!panel) return;

    const bounds = panel.getBoundingClientRect();
    const isOutside =
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom;

    if (isOutside) closeModal();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal?.open) {
      event.preventDefault();
      closeModal();
    }
  });

  modal?.addEventListener("close", () => {
    document.body.classList.remove("modal-open");
    if (returnFocusTarget instanceof HTMLElement) returnFocusTarget.focus();
  });

  const buyBox = document.querySelector("#buy-box");
  const stickyCart = document.querySelector(".sticky-cart");
  const stickyButton = document.querySelector("[data-scroll-buy-box]");

  if (buyBox && stickyCart && "IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const hasPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyCart.classList.toggle("is-visible", hasPassed);
      },
      { threshold: 0 }
    );

    observer.observe(buyBox);
  }

  stickyButton?.addEventListener("click", () => {
    buyBox?.scrollIntoView({ behavior: "smooth", block: "center" });
  });
})();
